/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

export type DashboardCreateUserGender =
  (typeof DashboardCreateUserGender)[keyof typeof DashboardCreateUserGender];

export const DashboardCreateUserGender = {
  Male: "Male",
  Female: "Female",
} as const;
